<template>
  <div class="main_infor">
    <p class="no_content" v-if="list.length === 0">暂无内容</p>
    <div v-if="list.length > 0">
      <div class="main_infor_image">
        <el-image class="image" lazy :src="list[listIndex].logo" fit="contain">
          <div slot="error" class="image_error">暂无图片</div>
        </el-image>
      </div>
      <div class="main_infor_content pointer" @click="toDetail(list[listIndex])">
        <h2 class="main_infor_content_title">{{ list[listIndex].title }}</h2>
        <p class="main_infor_content_time" @mouseenter="hoverFlag = true" @mouseleave="hoverFlag = false"><img v-if="!hoverFlag" src="@/assets/clock-icon.png" /><img v-if="hoverFlag" src="@/assets/clock-h-icon.png" /><span>发布日期 {{ list[listIndex].createdAt | dateFormat }}</span></p>
        <p class="main_infor_content_text">{{ list[listIndex].content }}</p>
        <div class="main_infor_content_images" @click.stop="">
          <img v-if="noLeft" class="left_btn image_btn" src="./image/no_left_icon.png">
          <img v-if="!noLeft" class="left_btn image_btn" @click="onLeft" src="./image/left_icon.png">
          <div class="images">
            <div v-for="(item, index) in list" :key="item.id" @click.stop="listIndex = index" class="image pointer" :class="{'image_act': index === listIndex}">
              <div v-if="index !== listIndex" class="image_shadow"></div>
              <el-image class="el_image" :src="item.logo" fit="cover">
                <div slot="error" class="image_error">暂无图片</div>
              </el-image>
            </div>
          </div>
          <img v-if="noRight" class="right_btn image_btn" src="./image/no_right_icon.png">
          <img v-if="!noRight" class="right_btn image_btn" @click="onRight" src="./image/right_icon.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mainInfor',
  props: ['zxzx'],
  components: {},
  data () {
    return {
      pageNum: 0,
      listIndex: 0,
      hoverFlag: false
    }
  },
  activated () {},
  created () {},
  mounted () {
  },
  computed: {
    list () {
      let list = []
      if (this.zxzx.length > 0) {
        for (let i = 0; i < 3; i++) {
          list.push(this.zxzx[this.pageNum + i])
        }
      }
      return list
    },
    total () {
      return this.zxzx.length || 0
    },
    noLeft () {
      return this.pageNum === 0
    },
    noRight () {
      return this.pageNum + 3 >= this.total
    }
  },
  methods: {
    toDetail (item) {
      /**
       *  李颍杰  14:07:21
       *  TREND("1", "定向动态", "定向动态"),
       *  MATCH("2", "活动赛事", "活动赛事"),
       *  TRAIN("3", "教研培训", "教研培训"),
       *  EQUIP("4", "定向装备", "定向装备"),
       *  TEACHER("5", "教师风采", "教师风采"),
       *  SCHOOL("6", "学校风采", "学校风采");
       *  SCHOOL("7", "儿童定向", "儿童定向");
       */
      let path = ''
      switch (parseInt(item.cls)) {
        case 1:
          // 定向动态
          path = '/dynamic/detail'
          break
        case 2:
          // 活动赛事
          path = '/game/detail'
          break
        case 3:
          // 教研培训
          path = '/train/detail'
          break
        case 4:
          // 定向装备
          path = '/equip/detail'
          break
        case 5:
          // 教师风采
          path = '/mien/tDetail'
          break
        case 6:
          // 学校风采
          path = '/mien/sDetail'
          break
        case 7:
          // 儿童定向
          path = '/orient/detail'
          break
      }
      this.$router.push({
        path: path,
        query: {
          itemId: item.id
        }
      })
    },
    onRight () {
      if (this.listIndex < 2) {
        this.listIndex++
      } else {
        this.pageNum++
      }
    },
    onLeft () {
      if (this.listIndex > 0) {
        this.listIndex--
      } else {
        this.pageNum--
      }
    }
  },
  watch: {}
}
</script>

<style scoped>
  .main_infor {width: 1000px;height: 320px;border-radius: 2px;border: 1px solid #DCDFE6; margin-bottom: 20px;}
  .main_infor > div {width: 100%; height: 100%;}
  .main_infor_image {width: 50%;height: 100%;border-radius: 2px;background-color: #DCDFE6;float: left;}
  .main_infor .main_infor_image .image { width: 100%; height: 100%; border-radius: 2px; }
  .main_infor .main_infor_content {width: 50%;height: 100%;float: right;padding: 10px;position: relative;}
  .main_infor .main_infor_content .main_infor_content_title { font-size: 18px; font-weight: 600; color: #333333; line-height: 25px; margin-bottom: 10px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
  .main_infor .main_infor_content .main_infor_content_time { margin-bottom: 10px; }
  .main_infor .main_infor_content .main_infor_content_time img { width: 12px; height: 12px; margin-right: 5px; }
  .main_infor .main_infor_content .main_infor_content_time span { font-size: 12px; font-weight: 400; color: #999999; line-height: 12px; }
  .main_infor .main_infor_content .main_infor_content_text { font-size: 14px; font-weight: 400; color: rgba(102,102,102,1); line-height: 20px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; }
  .main_infor .main_infor_content .main_infor_content_title:hover, .main_infor .main_infor_content .main_infor_content_text:hover { color: #76BF28; }
  .main_infor .main_infor_content .main_infor_content_time:hover span { color: #99C767; }
  .main_infor .main_infor_content .main_infor_content_images { position: absolute; width: 100%; height: 140px; bottom: 0; left: 0; padding: 10px; display: flex; justify-content: space-between; align-items: center; }
  .main_infor .main_infor_content .main_infor_content_images .image_btn { width: 30px; height: 30px; }
  .main_infor .main_infor_content .images { width: 380px; height: 120px; }
  .main_infor .main_infor_content .main_infor_content_images .image { width: 120px; height: 120px; overflow: hidden; margin-right: 10px; border-radius:  2px; border: 1px solid rgba(0, 0, 0, 0.35); float: left; position: relative; }
  .main_infor .main_infor_content .main_infor_content_images .el_image {width: 120px; height: 120px;}
  .main_infor .main_infor_content .main_infor_content_images .image_shadow { position: absolute; top: 0; left: 0; width: 120px; height: 120px; background-color: rgba(0, 0, 0, 0.35); z-index: 1; }
  .main_infor .main_infor_content .main_infor_content_images .image:last-child {  margin-right: 0px; }
  .main_infor .main_infor_content .main_infor_content_images .image_act { border: 1px solid #76BF28; }
</style>



// WEBPACK FOOTER //
// src/components/main/infor.vue